package org.chiangmeng.qfast.features.auth

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.PasswordVisualTransformation
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import cafe.adriel.voyager.core.screen.Screen
import cafe.adriel.voyager.koin.koinScreenModel
import cafe.adriel.voyager.navigator.LocalNavigator
import cafe.adriel.voyager.navigator.currentOrThrow
import org.chiangmeng.qfast.core.ui.staff.StaffScreen
import org.chiangmeng.qfast.core.ui.theme.QFastTheme
import org.chiangmeng.qfast.features.auth.AppleSignInButton

class AuthScreen : Screen {
    @Composable
    override fun Content() {
        val viewModel = koinScreenModel<AuthViewModel>()
        val navigator = LocalNavigator.currentOrThrow
        val uiState by viewModel.uiState.collectAsState()

        LaunchedEffect(Unit) {
            viewModel.checkInitialAuth()
        }

        LaunchedEffect(uiState) {
            if (uiState is AuthUiState.Authenticated) {
                val shopId = (uiState as AuthUiState.Authenticated).shopId
                navigator.replaceAll(StaffScreen(shopId = shopId))
            }
        }

        QFastTheme {
            Box(
                modifier = Modifier
                    .fillMaxSize()
                    .background(Color(0xFF0F172A)),
                contentAlignment = Alignment.Center
            ) {
                Card(
                    modifier = Modifier
                        .widthIn(max = 440.dp)
                        .fillMaxWidth()
                        .padding(24.dp),
                    shape = RoundedCornerShape(16.dp),
                    colors = CardDefaults.cardColors(containerColor = Color(0xFF1E293B))
                ) {
                    Column(
                        modifier = Modifier.padding(28.dp),
                        horizontalAlignment = Alignment.CenterHorizontally,
                        verticalArrangement = Arrangement.spacedBy(16.dp)
                    ) {
                        Text(
                            text = "เข้าสู่ระบบ QFast",
                            fontSize = 22.sp,
                            fontWeight = FontWeight.Bold,
                            color = Color.White
                        )

                        if (uiState is AuthUiState.Error) {
                            Text(
                                text = (uiState as AuthUiState.Error).message,
                                color = MaterialTheme.colorScheme.error,
                                fontSize = 14.sp
                            )
                        }

                        AppleSignInButton(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(48.dp),
                            enabled = uiState !is AuthUiState.Loading,
                            onTokenReceived = { idToken, rawNonce ->
                                viewModel.signInWithApple(idToken, rawNonce)
                            }
                        )
                        Spacer(modifier = Modifier.height(8.dp))
                        GoogleSignInButton(
                            modifier = Modifier
                                .fillMaxWidth()
                                .height(48.dp),
                            enabled = uiState !is AuthUiState.Loading,
                            onTokenReceived = { idToken, accessToken ->
                                viewModel.signInWithGoogle(idToken, accessToken)
                            },
                            onError = { errorMessage ->
                                viewModel.setManualError(errorMessage)
                            }
                        )
                    }
                }
            }
        }
    }
}
